<div [class.hidden]="!isSpinnerOpen">
  <span class="loading-text">{{ loadingText }}</span>
  <img class="image01" src="assets/images/loading-circle-01.svg" width="60" height="60" />
  <img class="image02" src="assets/images/loading-circle-02.svg" width="60" height="60" />
  <img class="image03" src="assets/images/loading-circle-03.svg" width="60" height="60" />
</div>



// WEBPACK FOOTER //
// ./src/app/components/_shared/loading-spinner/loading-spinner.component.html